/* eslint-disable no-unused-vars */
import Vue from "vue";

export default {
	state: {
		scores: [],
		score: {}
	},
	mutations: {
		setScoresOnState(state, scores) {
			state.scores = scores;
		},
		setScoreOnState(state, score) {
			state.score = score;
		}
	},
	actions: {
		getScores({ commit }) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("score")
					.then((response) => {
						commit("setScoresOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		getScore({ commit }, id) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("score/" + id)
					.then((response) => {
						commit("setScoreOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		createScore({ dispatch }, score) {
			dispatch("mapToCreate", score, score).then((object) => {
				return new Promise((resolve, reject) => {
					Vue.prototype.$http
						.post("score", object)
						.then((response) => {
							resolve(response.data.data);
						})
						.catch((error) => {
							reject(error);
						});
				});
			});
		},
		deleteScore({ commit }, score) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.delete("score/" + score.id + "/" + score.login)
					.then((response) => {
						resolve();
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		editScore({ dispatch }, score) {
			return new Promise((resolve, reject) => {
				dispatch("mapToCreate", score, score)
					.then((object) => {
						Vue.prototype.$http
							.put("score/" + score.idScore, object)
							.then((response) => {
								resolve();
							})
							.catch((error) => {
								reject(error);
							});
					})
					.catch((error) => {
						reject(error);
					});
			});
		},

		mapToCreate(_, score) {
			return new Promise((resolve) => {
				let request = {
					type: score.type,
					description: score.description,
					range: {},
					list: [],
					login: score.login
				};

				if (score.data.maxValue) {
					request.range["min"] = parseInt(score.data.minValue);
					request.range["max"] = parseInt(score.data.maxValue);
				}
				if (score.data.length) {
					request.list = score.data;
					request.type = 2;
				}

				resolve(request);
			});
		}
	},
	getters: {
		score({ score }) {
			return score;
		},
		scores({ scores }) {
			return scores;
		}
	}
};
